import { Sport } from '#src/__generated__/globalTypes.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

export const useEnableSetFeatures = () => {
  const { sport } = useSportContext();
  return sport !== Sport.BASEBALL;
};
